// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2LVPO","legacyBtn":"MutateMid_legacyBtn__2Imo4"};